import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { OldLegalDocumentDto } from '@model/LegalDocumentDto'

interface IntroducingBrokerLegalDocumentsParams {
  legalDocumentsSchemes: string
}

interface IntroducingBrokerLegalDocuments {
  data?: OldLegalDocumentDto[]
  isLoading: boolean
}

export const useIntroducingBrokerLegalDocuments = (
  props: IntroducingBrokerLegalDocumentsParams
): IntroducingBrokerLegalDocuments => {
  const { legalDocumentsSchemes } = props

  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.ibLegalDocuments(locale, legalDocumentsSchemes),
    queryFn: () => apiClient.getIntroducingBrokerLegalDocuments(locale, legalDocumentsSchemes),
  })

  return {
    data,
    isLoading,
  }
}
